import React from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  FACEBOOK_URL,
  INSTAGRAM_URL,
  LINKEDIN_URL,
  YOUTUBE_URL,
} from "../../utils/constants";

function Footer() {
  const handleSubscribe = () => {
    toast.success(
      `Thank you for subscribing to our newsletter! Stay tuned for updates.`,
    );
  };
  return (
    <footer className="dark:bg-gray-900 pt-12 pb-6 px-4 border-2">
      <div className="container  py-12 mx-auto">
        <div className="grid grid-cols-1  sm:grid-cols-2 sm:gap-y-2 lg:grid-cols-6 ">
          <div className="lg:col-span-3 sm:grid-cols-1  ">
            <h1 className="max-w-lg text-xl font-semibold tracking-tight text-gray-800 xl:text-2xl dark:text-white">
              Subscribe our newsletter to get update.
            </h1>

            <div className="flex flex-col mx-auto mt-6 space-y-3 md:space-y-0 md:flex-row">
              <input
                id="email"
                type="text"
                className="px-4 py-2 text-gray-700 bg-white border rounded-md dark:bg-gray-900 dark:text-gray-300 dark:border-gray-600 focus:border-blue-400 dark:focus:border-blue-300 focus:outline-none focus:ring focus:ring-opacity-40 focus:ring-blue-300"
                placeholder="Email Address"
              />

              <button
                className="w-full px-6 py-2.5 text-sm font-medium tracking-wider text-white transition-colors duration-300 transform md:w-auto md:mx-4 focus:outline-none bg-gray-800 rounded-lg hover:bg-gray-700 focus:ring focus:ring-gray-300 focus:ring-opacity-80"
                type="submit"
                onClick={handleSubscribe}
              >
                Subscribe
              </button>
            </div>
            <div className="pt-8">
              <p className="text-gray-600 transition-colors duration-300 dark:text-gray-300 dark:hover:text-blue-400   no-underline font-sans">
                <span className="font-semibold">
                  Acuvisor Insurance Brokers (India) Private Limited.
                </span>
                <br />
                IRDAI License No. 729, Direct Broker (Life & General),
                <br />
                Valid upto: 15/09/2026 (Renewable)
                <br />
                Principal Officer: Nitin Ghurye
                <br />
                020-40065077, +91-9963507262
                <br />
                CIN Number: U66000RJ2019PTC066575
              </p>
            </div>
          </div>

          <div className="lg:col-span-1"> </div>

          <div className="sm:col-span-1 lg:col-span-1 items-center font-sans">
            <p className="font-semibold text-gray-800 dark:text-white flex flex-col items-center">
              Quick Link
            </p>

            <div className="flex flex-col items-center mt-2 space-y-2 ">
              <Link
                to="/"
                className="text-gray-600 transition-colors duration-300 dark:text-gray-300 dark:hover:text-blue-400 hover:underline hover:text-blue-500 no-underline"
              >
                Home
              </Link>
              <Link
                to="/about-us"
                className="text-gray-600 transition-colors duration-300 dark:text-gray-300 dark:hover:text-blue-400 hover:underline hover:text-blue-500 no-underline"
              >
                About-Us
              </Link>
              <Link
                to="/our-team"
                className="text-gray-600 transition-colors duration-300 dark:text-gray-300 dark:hover:text-blue-400 hover:underline hover:text-blue-500 no-underline"
              >
                Our Team
              </Link>
              <Link
                to="/career"
                className="text-gray-600 transition-colors duration-300 dark:text-gray-300 dark:hover:text-blue-400 hover:underline hover:text-blue-500 no-underline"
              >
                Career
              </Link>
              <Link
                to="/contact-us"
                className="text-gray-600 transition-colors duration-300 dark:text-gray-300 dark:hover:text-blue-400 hover:underline hover:text-blue-500 no-underline"
              >
                Contact Us
              </Link>
            </div>
          </div>

          <div className="sm:col-span-1 lg:col-span-1 font-sans">
            <p className="font-semibold text-gray-800 dark:text-white flex flex-col items-center">
              Useful Links
            </p>

            <div className="flex flex-col items-center mt-2 space-y-2 ">
              <Link
                to="/privacy-policy"
                className="text-gray-600 transition-colors duration-300 dark:text-gray-300 dark:hover:text-blue-400 hover:underline hover:text-blue-500 no-underline"
              >
                Privacy Policy
              </Link>
              <Link
                to="/grievance"
                className="text-gray-600 transition-colors duration-300 dark:text-gray-300 dark:hover:text-blue-400 hover:underline hover:text-blue-500 no-underline"
              >
                Grievance
              </Link>
              <Link
                to="/terms-of-use"
                className="text-gray-600 transition-colors duration-300 dark:text-gray-300 dark:hover:text-blue-400 hover:underline hover:text-blue-500 no-underline"
              >
                Terms Of Use
              </Link>
              <Link
                to="/disclaimer"
                className="text-gray-600 transition-colors duration-300 dark:text-gray-300 dark:hover:text-blue-400 hover:underline hover:text-blue-500 no-underline"
              >
                Disclaimer
              </Link>
            </div>
          </div>
        </div>

        <hr className="my-3 border-gray-500 md:my-8 dark:border-gray-700" />

        <div className="flex justify-between ">
          <div className="flex w-96 gap-4 ">
            {/* <img className="w-32 h-12" src="./images/logo 3.png" alt="" /> */}

            <img
              className="w-32 h-10"
              src="/images/footer-logo.png"
              alt="acuvisors irdai footer logo"
            />
          </div>

          <div className="flex items-center justify-center space-x-4">
            <a
              href={YOUTUBE_URL}
              className="text-gray-600 transition-colors duration-300 dark:text-gray-300 hover:text-red-500 dark:hover:text-red-500"
              aria-label="YouTube"
            >
              <svg
                className="w-9 h-9"
                viewBox="0 0 48 48"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
              >
                <path d="M44.5 13.2c-.5-1.8-1.9-3.3-3.7-3.7C37.7 8.8 24 8.8 24 8.8s-13.7 0-16.8.7c-1.8.5-3.3 1.9-3.7 3.7C3 16.4 3 24 3 24s0 7.6.5 10.8c.5 1.8 1.9 3.3 3.7 3.7 3.1.7 16.8.7 16.8.7s13.7 0 16.8-.7c1.8-.5 3.3-1.9 3.7-3.7.5-3.2.5-10.8.5-10.8s0-7.6-.5-10.8zM20 30.1V17.9L31 24l-11 6.1z" />
              </svg>
            </a>

            <a
              href={FACEBOOK_URL}
              className="text-gray-600 transition-colors duration-300 dark:text-gray-300 hover:text-blue-500 dark:hover:text-blue-400"
              aria-label="Facebook"
            >
              <svg
                className="w-9 h-9 fill-current"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M2.00195 12.002C2.00312 16.9214 5.58036 21.1101 10.439 21.881V14.892H7.90195V12.002H10.442V9.80204C10.3284 8.75958 10.6845 7.72064 11.4136 6.96698C12.1427 6.21332 13.1693 5.82306 14.215 5.90204C14.9655 5.91417 15.7141 5.98101 16.455 6.10205V8.56104H15.191C14.7558 8.50405 14.3183 8.64777 14.0017 8.95171C13.6851 9.25566 13.5237 9.68693 13.563 10.124V12.002H16.334L15.891 14.893H13.563V21.881C18.8174 21.0506 22.502 16.2518 21.9475 10.9611C21.3929 5.67041 16.7932 1.73997 11.4808 2.01722C6.16831 2.29447 2.0028 6.68235 2.00195 12.002Z"></path>
              </svg>
            </a>

            <a
              href={INSTAGRAM_URL}
              className="text-gray-600 transition-colors duration-300 dark:text-gray-300 hover:text-pink-500"
              aria-label="Instagram"
            >
              <svg
                className="w-9 h-9 fill-current transition-colors duration-300"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill="currentColor"
                  d="M12 2.163C6.477 2.163 2 6.645 2 12.2c0 5.556 4.477 10.038 10 10.038s10-4.482 10-10.038c0-5.555-4.477-10.037-10-10.037zM12 17.2a5.002 5.002 0 110-10.004A5.002 5.002 0 0112 17.2zm6.406-9.81a1.444 1.444 0 11-2.89-.001 1.444 1.444 0 012.89 0zM12 8.67a3.33 3.33 0 100 6.659 3.33 3.33 0 000-6.66z"
                ></path>
              </svg>
            </a>

            <a
              href={LINKEDIN_URL}
              className="text-gray-600 transition-colors duration-300 dark:text-gray-300 hover:text-blue-500 dark:hover:text-blue-500"
              aria-label="LinkedIn"
            >
              <svg
                className="w-9 h-9"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M19 0h-14c-1.104 0-2 .896-2 2v20c0 1.104.896 2 2 2h14c1.104 0 2-.896 2-2v-20c0-1.104-.896-2-2-2zm-11 18h-3v-9h3v9zm-1.5-10.3c-.966 0-1.5-.734-1.5-1.5s.534-1.5 1.5-1.5c.967 0 1.5.734 1.5 1.5s-.533 1.5-1.5 1.5zm12.5 10.3h-3v-4.8c0-1.144-.409-1.9-1.433-1.9-1.085 0-1.567.728-1.567 1.875v4.825h-3v-9h3v1.25h.042c.418-.75 1.5-1.5 3-1.5 2.7 0 4.5 1.8 4.5 5.25v4.25z" />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
